export const SMALL_OUTPUT_THRESHOLD = 3;
